import { map, pipe, toPairs } from 'ramda';
import { countries, languagesAll } from 'countries-list';

export function getCountriesAll() {
  const fixedContries = {
    ...countries,
    BR: {
      ...countries.BR,
      languages: ['pt-br', 'pt'],
    },
    MX: {
      ...countries.MX,
      languages: ['es-mx', 'es'],
    },
  };

  const sortedCountries = Object.keys(fixedContries)
    .sort() // Sort the keys alphabetically
    .reduce((sortedObj, key) => {
      sortedObj[key] = fixedContries[key]; // Rebuild the object with sorted keys
      return sortedObj;
    }, {});

  return sortedCountries;
}

export function getLanguagesAll() {
  const addedLanguages = {
    'es-mx': {
      name: 'Spanish (Mexico)',
      native: 'Español (México)',
    },
    'pt-br': {
      name: 'Portuguese (Brazil)',
      native: 'Português (Brasil)',
    },
  };

  const updatedLanguages = { ...languagesAll, ...addedLanguages };

  const sortedLanguages = Object.keys(updatedLanguages)
    .sort() // Sort the keys alphabetically
    .reduce((sortedObj, key) => {
      sortedObj[key] = updatedLanguages[key]; // Rebuild the object with sorted keys
      return sortedObj;
    }, {});

  return sortedLanguages;
}

export function getFormattedLanguagesArr() {
  const newLangAll = getLanguagesAll();

  const languagesArr = pipe(
    toPairs,
    map((item) => ({ value: item[0], title: item[1].native }))
  )(newLangAll);

  return languagesArr.sort((a, b) => {
    if (a.title < b.title) return -1; // a comes first
    if (a.title > b.title) return 1; // b comes first
    return 0; // a and b are equal
  });
}

export function getFormattedCountriesArr() {
  const newCountriesAll = getCountriesAll();

  const countriesArr = pipe(
    toPairs,
    map((item) => ({ code: item[0], name: item[1] }))
  )(newCountriesAll);

  return countriesArr;
}

// to change hardcoded, languages available in mobile
export const languagesAvailableOnMobile = [
  { value: 'en', title: 'English' },
  { value: 'es-mx', title: 'Español (Mexico)' },
  { value: 'fr', title: 'Français' },
  { value: 'id', title: 'Bahasa Indonesia' },
  { value: 'pt-br', title: 'Português (Brasil)' },
];
